import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import parse, { domToReact, HTMLReactParserOptions } from "html-react-parser";
import * as React from "react";

export const xParserOptions: HTMLReactParserOptions = {
    replace: node => {
        const { name, children, attribs = { style: "" }, ...rest } = node;
        const { style, class: className, ...otherAttribs } = attribs;

        otherAttribs.className = className;

        if (name && ["html", "body"].includes(name) && children) {
            return <>{children && domToReact(children, xParserOptions)}</>;
        }
        if (name === "head") {
            return <></>;
        }
        return parserOptions.replace(node);
    },
};

export const xParse = parse;
